module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-500.19fd96f6.woff2";